import { Component } from '@angular/core';
import { License, LicenseBundleToUpdate } from '@app/models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FullscreenLoaderService, IosDialogService, LicensesService, ToastService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { MessageType } from '@app/shared';

@Component({
  selector: 'app-license-detail',
  templateUrl: './license-detail.component.html',
  styleUrls: ['./license-detail.component.scss'],
})
export class LicenseDetailComponent {
  license: License;
  copied: boolean = false;
  loading = false;
  needToBlink = false;

  constructor(
    { data }: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private dialog: IosDialogService,
    private translate: TranslateService,
    private toastService: ToastService,
    private licenseService: LicensesService,
    private fullscreenLoaderService: FullscreenLoaderService,
  ) {
    this.license = data.license;
  }

  getLicenseSameActivationTime() {
    return this.license.licenseBundle?.activationTime && this.license.licenseBundle.activationTime.getTime() == this.license.activationTime.getTime();
  }

  renewOfflineLicense() {
    this.loading = true;
    try {
      const updateOnlyThisLicense = this.license.offlineLicenseKey != null;
      const licenseBundleId = this.license.licenseBundle?.licenseBundleId;
      this.fullscreenLoaderService.start();
      this.licenseService.renewOfflineLicenseKey(this.license.licenseId).subscribe({
        next: (value) => {
          if (updateOnlyThisLicense) {
            this.license.offlineLicenseKey = value.offlineLicenseKey;
            this.license.offlineLicenseKeyExpirationTime = value.offlineLicenseKeyExpirationTime;
          } else {
            this.license.licenseBundle.offlineLicenseKey = value.offlineLicenseKey;
            this.license.licenseBundle.offlineLicenseKeyExpirationTime = value.offlineLicenseKeyExpirationTime;
            this.licenseService.updateLicenseBundleById$.next(
              new LicenseBundleToUpdate({
                licenseBundleId,
                offlineLicenseKey: value.offlineLicenseKey,
                offlineLicenseKeyExpirationTime: value.offlineLicenseKeyExpirationTime,
              }),
            );
          }
          this.blinkFields();
          this.toastService.showToast(MessageType.SUCCESS, this.translate.instant('TOAST.LICENSE_RENEWED'));
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
          this.toastService.showErrorToast(err);
          this.fullscreenLoaderService.stop();
        },
        complete: () => {
          this.loading = false;
          this.fullscreenLoaderService.stop();
        },
      });
    } catch (err) {
      console.error(err);
      this.loading = false;
      this.toastService.showToast(MessageType.ERROR);
    }
  }

  blinkFields() {
    this.needToBlink = true;

    setTimeout(() => {
      this.needToBlink = false;
    }, 1500);
  }
}
